export interface AttributionParams{
  channel?: string;
  subchannel?: string;
}

export const EpJsAttributionKey = 'epjs_attribution';
